var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg171(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22198 11.045C9.50559 11.1753 9.8416 11.0913 10.0307 10.843L10.2673 10.533C10.5191 10.1973 10.9143 9.99967 11.334 9.99967H13.334C14.0704 9.99967 14.6673 10.5966 14.6673 11.333V13.333C14.6673 14.0694 14.0704 14.6663 13.334 14.6663C6.70657 14.6663 1.33398 9.29376 1.33398 2.66634C1.33398 1.93045 1.93143 1.33301 2.66732 1.33301H4.66732C5.4032 1.33301 6.00065 1.93045 6.00065 2.66634V4.66634C6.00065 5.08602 5.80306 5.4812 5.46732 5.73301L5.15532 5.96701C4.90297 6.15969 4.82152 6.50361 4.96065 6.78901C5.87177 8.63959 7.37027 10.1362 9.22198 11.045",
    stroke: "#94A3B8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg171);
export default __webpack_public_path__ + "static/media/svg171.a9afd8e58b8c73069734512776fb7741.svg";
export { ForwardRef as ReactComponent };